import React, { useState } from "react"
import StyledSelect from "./Select.style"
import { Link, navigate } from "gatsby"
import { randomID } from "../../particles/helpers"

const Select = ({
  options,
  value,
  width,
  updateState,
  sort,
  className,
  style,
  background = {
    backgroundColor: `#FFFFFF`,
    backgroundOpacity: 100,
  },
  lightBackground,
}: SelectProps) => {
  const [isOpen, setOpen] = useState(false)

  const updateMenu = e => {
    e.preventDefault
    setOpen(!isOpen)
  }
  if (sort) {
    options.sort(function(a, b) {
      if (a.label > b.label) {
        return 1
      }
      if (b.label > a.label) {
        return -1
      }
      return 0
    })
  }

  return (
    <ul
      css={StyledSelect({
        width: width,
        background: background,
        lightBackground: lightBackground || undefined,
      })}
      className={(isOpen ? "open " : "") + className}
      onClick={updateMenu}
      style={style}
    >
      <li>{value}</li>
      <ul>
        {options.map(option =>
          option.link ? (
            <Link to={option.link} key={randomID()}>
              <li
                value={option.value}
                onClick={
                  updateState
                    ? () => {
                        updateState({
                          type: "UPDATE_BRANCH",
                          branch: option.value,
                        })
                        if (option.value !== "All Branches") {
                          navigate(
                            `/branch/${option.value
                              .replace(/\s+/g, "-")
                              .replace(/\./g, "")
                              .toLowerCase()}`
                          )
                        }
                      }
                    : undefined
                }
              >
                {option.label}
              </li>
            </Link>
          ) : (
            <li
              value={option.value}
              key={option.value}
              onClick={
                updateState
                  ? () => {
                      updateState({
                        type: "UPDATE_BRANCH",
                        branch: option.value,
                      })
                      if (option.value !== "All Branches") {
                        navigate(
                          `/branch/${option.value
                            .replace(/\s+/g, "-")
                            .replace(/\./g, "")
                            .toLowerCase()}`
                        )
                      }
                    }
                  : undefined
              }
            >
              {option.label}
            </li>
          )
        )}
      </ul>
    </ul>
  )
}

type Options = {
  label: string
  value: string
  link?: string
}

type SelectProps = {
  options: Array<Options>
  background: {
    backgroundColor: string
    backgroundOpacity: number
  }
  width: number
  value: string
  updateState?: any
  className?: string
  style?: {}
  sort?
  lightBackground?
}

export default Select
